import type { TFunction } from "i18next"
import { NotificationTypes, type NotificationDto } from "@/entities/notification/types"
import { DepositRecordStatusCode } from "@/entities/deposit/types"

/** Имена `DepositRecordStatus` с бэка в тексте уведомления + черновик. */
const DEPOSIT_STATUS_ENUM_TOKEN_TO_CODE: Record<string, number> = {
  Draft: 0,
  PendingModeration: DepositRecordStatusCode.PendingModeration,
  Confirmed: DepositRecordStatusCode.Confirmed,
  Rejected: DepositRecordStatusCode.Rejected,
  TeamReview: DepositRecordStatusCode.TeamReview,
  NeedsRevision: DepositRecordStatusCode.NeedsRevision,
}

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

const localizeDepositStatusTokens = (text: string, t: TFunction): string => {
  let out = text
  const entries = Object.entries(DEPOSIT_STATUS_ENUM_TOKEN_TO_CODE).sort((a, b) => b[0].length - a[0].length)
  for (const [enumName, code] of entries) {
    const label = t(`data.depositRecordStatus.${code}`)
    if (label === `data.depositRecordStatus.${code}`) continue
    const re = new RegExp(`\\b${escapeRegExp(enumName)}\\b`, "g")
    out = out.replace(re, label)
  }
  return out
}

type NotificationCopyInput = Pick<NotificationDto, "type" | "title" | "body">

/** Подмена английских имён enum статуса депозита в title/body на текущую локаль. */
export const formatNotificationDisplayFields = (
  n: NotificationCopyInput,
  t: TFunction,
): { title: string; body: string | null | undefined } => {
  if (n.type === NotificationTypes.DepositStatusChanged) {
    return {
      title: localizeDepositStatusTokens(n.title, t),
      body: n.body == null || n.body === "" ? n.body : localizeDepositStatusTokens(n.body, t),
    }
  }
  return { title: n.title, body: n.body }
}
